import { Row, Col, Tag, Space } from "antd";
import { CheckCircleFilled } from "@ant-design/icons";

// Caja de "ya identificado en BD": fondo blanco neutro, con un borde
// izquierdo verde discreto como unico acento de color (en vez de rellenar
// todo el bloque de color, que sobrecarga la vista cuando hay varios juntos).
export const BloqueResuelto = ({ oid, identificacion, texto }) => (
  <div
    style={{
      minHeight: 44,
      display: "flex",
      alignItems: "center",
      gap: 10,
      padding: "10px 14px",
      background: "#ffffff",
      border: "1px solid #e8e8e8",
      borderLeft: "3px solid #52c41a",
      borderRadius: 6,
    }}
  >
    <CheckCircleFilled style={{ color: "#52c41a", flexShrink: 0, fontSize: 16 }} />
    <Space direction="vertical" size={4} style={{ flex: 1, minWidth: 0 }}>
      <Space size={4} wrap>
        <Tag style={{ margin: 0, color: "#595959", background: "#f5f5f5", border: "1px solid #e8e8e8" }}>
          oid {oid}
        </Tag>
        {identificacion && (
          <Tag style={{ margin: 0, color: "#595959", background: "#f5f5f5", border: "1px solid #e8e8e8" }}>
            {identificacion}
          </Tag>
        )}
      </Space>
      <span style={{ fontWeight: 500, overflow: "hidden", textOverflow: "ellipsis", color: "#262626" }}>
        {texto || <i style={{ color: "#999", fontWeight: "normal" }}>Sin nombre registrado en BD</i>}
      </span>
    </Space>
  </div>
);

// Bloque "OCR detectó" | "En BD (editable)": sin fondos de color, solo texto
// y bordes grises suaves; el espacio entre renglones se da con margen, no
// con cajas anidadas una dentro de otra.
export const CompararOcrBd = ({ etiquetaOcr, valorOcr, noCoincide, children }) => (
  <Row gutter={20} style={{ marginBottom: 16 }} align="top">
    <Col xs={24} sm={11}>
      <div style={{ fontSize: 12, color: "#8c8c8c", marginBottom: 6, fontWeight: 500 }}>{etiquetaOcr}</div>
      <div
        style={{
          minHeight: 36,
          display: "flex",
          alignItems: "center",
          padding: "0 12px",
          background: "#fafafa",
          border: "1px solid #f0f0f0",
          borderRadius: 6,
          color: "#595959",
        }}
      >
        {valorOcr || <i style={{ color: "#bfbfbf" }}>no detectado por OCR</i>}
      </div>
    </Col>
    <Col xs={24} sm={13}>
      <div
        style={{
          fontSize: 12,
          color: "#8c8c8c",
          marginBottom: 6,
          fontWeight: 500,
          display: "flex",
          alignItems: "center",
          gap: 6,
        }}
      >
        En base de datos (editable)
        {/* Las banderas vienen de MySQL como 0/1 (numero), no true/false. Sin
            convertir a booleano, "0 && <Tag/>" renderiza el texto literal
            "0" en vez de no mostrar nada. */}
        {Boolean(noCoincide) && (
          <Tag color="warning" style={{ margin: 0 }}>
            difiere del OCR
          </Tag>
        )}
      </div>
      {children}
    </Col>
  </Row>
);
